export default __webpack_public_path__ + "static/shape_oval-cf88b554c619fdb93154e80c54d46bbf.png";